var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 13.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "blog") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,14H4.69A4.57,4.57,0,0,1,0,9.26V4.62A4.55,4.55,0,0,1,4.68,0a15.48,15.48,0,0,1,4,.45,3.79,3.79,0,0,1,2.6,3.42c.17,1.19.3,1.36,1.45,1.37A1.07,1.07,0,0,1,14,6.42c0,1.14.06,2.28,0,3.41A4.58,4.58,0,0,1,9.68,14C8.78,14,7.87,14,7,14ZM7,10.5H9.43c.61,0,1.06-.26,1.07-.89s-.45-.9-1.05-.9H4.56C4,8.7,3.5,9,3.5,9.59s.43.91,1,.91ZM5.71,5.24h0A3.69,3.69,0,0,0,7,5.21a1.47,1.47,0,0,0,.83-.9c0-.24-.47-.77-.78-.81a9.77,9.77,0,0,0-2.7,0,1.2,1.2,0,0,0-.81.87c0,.3.51.7.87.84A3.75,3.75,0,0,0,5.71,5.24Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.8015946b457b0b0fbea1adb3958417ca.svg";
export { ForwardRef as ReactComponent };